import React from 'react';

const Projects = () => {
  return (
    <section id="projects" className="py-16 bg-gray-50 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-indigo-600">
        Featured Projects
      </h2>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 px-4">

        {/* FRONTEND PROJECTS */}

        {/* Project 1 - E-commerce */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
          <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
            🛒 E-commerce Web Application
          </h3>
          <p className="text-gray-700 mb-4">
            Fully responsive e-commerce web app with product listings, shopping cart, and modern UI for online stores.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            <b>Tech:</b> React.js, JavaScript, CSS
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="https://magnificent-semifreddo-4992cb.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
            >
              Live
            </a>
            <a
              href="https://github.com/priyankayadav33"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-indigo-600 text-indigo-600 px-4 py-2 rounded hover:bg-indigo-600 hover:text-white"
            >
              Code
            </a>
          </div>
        </div>

        {/* Project 2 - E-commerce Admin Dashboard */}
<div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
  <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
    📊 E-commerce Admin Dashboard
  </h3>
  <p className="text-gray-700 mb-4">
    Admin dashboard for managing e-commerce products, orders, and store data with a modern responsive UI.
  </p>
  <p className="text-sm text-gray-500 mb-4">
    <b>Tech:</b> React.js, JavaScript, CSS
  </p>
  <div className="flex justify-center gap-4">
    <a
      href="https://priyanka-dashboard.netlify.app/"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
    >
      Live
    </a>
    <a
      href="https://github.com/priyankayadav33"
      target="_blank"
      rel="noopener noreferrer"
      className="border border-indigo-600 text-indigo-600 px-4 py-2 rounded hover:bg-indigo-600 hover:text-white"
    >
      Code
    </a>
  </div>
</div>

        {/* Project 2 - Finance */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
          <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
            💰 Finance Business Website
          </h3>
          <p className="text-gray-700 mb-4">
            Modern finance website with responsive design, smooth animations, and clean UI for financial services.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            <b>Tech:</b> HTML, CSS, JavaScript
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="https://animated-rabanadas-a238a0.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
            >
              Live
            </a>
            <a
              href="https://github.com/priyankayadav33"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-indigo-600 text-indigo-600 px-4 py-2 rounded hover:bg-indigo-600 hover:text-white"
            >
              Code
            </a>
          </div>
        </div>

        {/* Project 3 - Cybersecurity */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
          <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
            🔐 Cybersecurity Company Website
          </h3>
          <p className="text-gray-700 mb-4">
            Professional cybersecurity website designed for security services with modern UI and responsive layout.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            <b>Tech:</b> HTML, CSS
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="https://mellifluous-salmiakki-530eb1.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
            >
              Live
            </a>
            <a
              href="https://github.com/priyankayadav33"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-indigo-600 text-indigo-600 px-4 py-2 rounded hover:bg-indigo-600 hover:text-white"
            >
              Code
            </a>
          </div>
        </div>

        {/* Project 4 */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
          <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
            🌐 Business Website UI
          </h3>
          <p className="text-gray-700 mb-4">
            Fully responsive modern business website with clean layout and smooth user experience.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            <b>Tech:</b> HTML, CSS, JavaScript
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="https://mellifluous-narwhal-da92db.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
            >
              Live
            </a>
            <a
              href="https://github.com/priyankayadav33"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-indigo-600 text-indigo-600 px-4 py-2 rounded hover:bg-indigo-600 hover:text-white"
            >
              Code
            </a>
          </div>
        </div>

        {/* BACKEND PROJECTS */}

        {/* Project 5 */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
          <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
            🌐 Intelligent Webpage Generator
          </h3>
          <p className="text-gray-700 mb-4">
            AI-based system generating dynamic profile pages using external data sources.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            <b>Tech:</b> Java, Spring Boot, PostgreSQL
          </p>
          <a
            href="https://github.com/priyankayadav33/Intelligent-webpage-generator"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            GitHub
          </a>
        </div>

        {/* Project 6 */}
        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300">
          <h3 className="text-2xl font-semibold mb-3 text-indigo-700">
            📊 Vehicle Telematics System
          </h3>
          <p className="text-gray-700 mb-4">
            Microservices-based system for tracking vehicle performance, alerts, and real-time data.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            <b>Tech:</b> Spring Boot, Kafka, MySQL, JWT
          </p>
          <a
            href="https://github.com/priyankayadav33/telematics-system"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            GitHub
          </a>
        </div>

      </div>
    </section>
  );
};

export default Projects;